export default "__VITE_ASSET__jTfH7KID__"